import * as es from './es.js';

// TODO translate
export default {
    ...es.default
};
